import React from 'react'

function SubTitle({content}) {
  return (
    <div className='text-xl font-bold pt-28 text-center font-heading'>{content}</div>
  )
}

export default SubTitle